import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import { retry, timeout, catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";

import { CustomerLegalForm } from "src/app/parametrage/core/model/customer-legal-form";
import { ActivityArea } from "src/app/parametrage/core/model/activity-area";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { Produit } from "src/app/parametrage/core/model/produit";
import { BpCorporate } from "src/app/parametrage/core/model/bp-corporate";
import { ActivityAreaService } from "src/app/parametrage/core/service/activity-area.service";
import { CustomerLegalFormService } from "src/app/parametrage/core/service/customer-legal-form.service";
import { ProduitService } from "src/app/parametrage/core/service/produit.service";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";
import { BpCorporateService } from "src/app/parametrage/core/service/bp-corporate.service";
import { CreateDossierCorporate } from "src/app/corporate/core/model/corporate/create-dossier-corporate";
import { CorporateFaciliteItem } from "src/app/corporate/core/model/corporate/corporate-facilite-item";
import { CorporateService } from "src/app/corporate/core/service/corporate.service";
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import {
  CustomAdapter,
  CustomDateParserFormatter,
} from "src/app/shared/adapters/datepicker-adapter";
import { RequestService } from 'src/app/parametrage/core/service/request.service';
import { Request } from 'src/app/parametrage/core/model/request';
import { Corporate } from 'src/app/parametrage/core/model/corporate';
import { RequestItem } from 'src/app/corporate/core/model/request-item';
import { RequestItemService } from 'src/app/corporate/core/service/request-item.service';

@Component({
  selector: "app-create-dossier-credit",
  templateUrl: "./create-dossier-credit.component.html",
  styleUrls: ["./create-dossier-credit.component.scss"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class CreateDossierCreditComponent implements OnInit {
  
  workflowCode: String;
  requestIdParent : String;
  dossier: Request;

  corporate: Corporate;
  facilites: RequestItem[];

  isProspect: boolean = false;

  codeClient: String = "";

  errorMessage: string;
  pressButton: Boolean = false;

  form: FormGroup;
  public creditList: FormArray;

  index: Number = 0;

  //returns all form groups under credits
  get creditFormGroup() {
    return this.form.get("credits") as FormArray;
  }

  //creditItems : DossierItem;

  legalForms: CustomerLegalForm[];
  secteurs: ActivityArea[];
  requestTypes: TypeCredit[];
  produits: Produit[];

  requestTypeArray: Array<TypeCredit[]> = [];
  produitArray: Array<Produit[]> = [];

  typeCreditLabel: Array<string[]> = [];

  dossierCredit: CreateDossierCorporate = new CreateDossierCorporate();

  bpCorporate: BpCorporate;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _activityAreaService: ActivityAreaService,
    private _customerLegalFormService: CustomerLegalFormService,
    private _bpCorporateService: BpCorporateService,
    private _produitService: ProduitService,
    private _typeCreditService: TypeCreditService,
    private _corporateService: CorporateService,
    private _requestService: RequestService,
    private _entrepriseService : CorporateService,
    private _requestItemService : RequestItemService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  checkProspect() {
    let typeClient = this.form.value.underType;
    if (typeClient == "prospect") {
      this.isProspect = true;
      this.form.controls["customerCode"].setValue("prospect");
    } else {
      this.isProspect = false;
      this.form.controls["customerCode"].setValue("");
    }
  }

  createForm() {
    this.form = this.fb.group({
      underType: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      categorie: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      dateReceptionDossier: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      customerCode: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      accountNumber: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      corporateName: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      sigle: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      tradeRegister: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      ncc: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      capitalSocial: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      city: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      email: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      telephone: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      secteur: [null, Validators.compose([Validators.required])],
      formeJuridique: [null, Validators.compose([Validators.required])],
      address: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],

      firstName: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      lastName: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      experience: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      fonction: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      emailDirigeant: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],
      telephoneDirigeant: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(254),
        ],
      ],

      credits: this.fb.array([this.createCredit()]),

      garantiesArrayForm: this.fb.array([]),
    });
    // set creditList to this field

    this.creditList = this.form.get("credits") as FormArray;
  }

  get garantiesArrayForm(): FormArray {
    return this.form.get("garantiesArrayForm") as FormArray;
  }
  garantiesData = [
    /*{ checked: true, require: true, displayName: 'ravi2', name: 'b', index: 1 },
    { checked: true, require: true, displayName: 'ravi3', name: 'c', index: 2 }*/
  ];

  // credit formgroup
  createCredit(): FormGroup {
    return this.fb.group({
      requestType: [null, Validators.compose([Validators.required])],
      produit: [null, Validators.compose([Validators.required])],
      tauxInteret: [
        "",
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      montant: [null, Validators.compose([Validators.required])],
      echeance: [
        "",
        [
          Validators.compose([Validators.required]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      nombreEcheance: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.required,
        ],
      ],

      payeurFinal: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(254)],
      ],
      commissionOperationCredit: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      fraisDossier: [null, Validators.compose([Validators.nullValidator])],
      commissionEngagement: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],

      objetFinancement: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(21843),
        ],
      ],
    });
  }

  // add a credit form group
  addCredit() {
    this.creditList.push(this.createCredit());

    var index = Number(this.index);
    const newIndex = index + 1;
    this.index = newIndex;
    this.getListTypeCredit(newIndex);
  }

  // remove credit from group
  removeCredit(index) {
    this.creditList.removeAt(index);
  }

  // get the formgroup under credits form array
  getCreditsFormGroup(index): FormGroup {
    const formGroup = this.creditList.controls[index] as FormGroup;
    return formGroup;
  }

  create(): void {
    //mapping credits et dossier
    const creditItems: CorporateFaciliteItem[] = [];
    this.form.value.credits.forEach(function (value) {
      const creditItem = new CorporateFaciliteItem();
      creditItem.commissionEngagement = value.commissionEngagement;
      creditItem.commissionOperationCredit = value.commissionOperationCredit;
      creditItem.echeance = value.echeance;
      creditItem.nombreEcheance = value.nombreEcheance;
      creditItem.payeurFinal = value.payeurFinal;
      creditItem.fraisDossier = value.fraisDossier;
      creditItem.montant = value.montant;
      creditItem.objetFinancement = value.objetFinancement;
      creditItem.produit = value.produit;
      creditItem.tauxInteret = value.tauxInteret;
      creditItems.push(creditItem);
    });
    this.dossierCredit.facilites = creditItems;

    const garanties = this.form.get("garantiesArrayForm").value;
    this.dossierCredit.garanties = garanties;

    if (this.dossierCredit.facilites.length == 0) {
      this.errorMessage = "Ajouter au moins un crédit";
    } else if (this.dossierCredit.secteur == null) {
      this.errorMessage = "Ajouter le secteur du client";
    } else if (this.dossierCredit.formeJuridique == null) {
      this.errorMessage = "Ajouter la forme juridique du client";
    } else {
      //save dossier de crédit
      this.pressButton = true;
      this.spinner.show();
      this._corporateService
        .createDossier(this.dossierCredit)
        .pipe(
          first(),
          finalize(() => {
            this.spinner.hide();
          })
        )
        .subscribe(
          (data) => {
            this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
          },
          (error) => {
            console.log(error);
            this.errorMessage = error.error.message;
            this.pressButton = false;
          }
        );
    }
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.workflowCode = params["workflowCode"];
      this.requestIdParent = params['requestIdParent'];
    });

    this.getAllLegalForm();
    this.getSecteur();
    this.getListTypeCredit(0);

    this.mappingDossier();
  }

  mappingDossier()
  {
    if(this.requestIdParent!=null)
    {
      this.getRequestById(this.requestIdParent);
      this.dossierCredit.requestIdParent = this.requestIdParent;
      this.initFormFromParent(this.requestIdParent);
    }
  }

  getRequestById(requestIdParent) {
    this._requestService.getRequestById(requestIdParent).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  initFormFromParent(requestIdParent) {
    this._entrepriseService.getCorporateByRequestId(requestIdParent).subscribe(
      (data) => {
        this.corporate = data;
        this.dossierCredit.customerCode = this.corporate.customerCode;
        this.dossierCredit.underType = this.corporate.underType;
        this.dossierCredit.categorie = this.corporate.categorie;
        this.dossierCredit.accountNumber = this.corporate.accountNumber;
        this.dossierCredit.customerCode = this.corporate.customerCode;
        this.dossierCredit.number = this.corporate.number;
        this.dossierCredit.ncc = this.corporate.ncc;
        this.dossierCredit.tradeRegister = this.corporate.tradeRegister;
        this.dossierCredit.corporateName = this.corporate.corporateName;
        this.dossierCredit.sigle = this.corporate.sigle;
        this.dossierCredit.capitalSocial = this.corporate.socialCapital;
        this.dossierCredit.city = this.corporate.city;
        this.dossierCredit.address = this.corporate.address;
        this.dossierCredit.email = this.corporate.email;
        this.dossierCredit.telephone = this.corporate.workPhone;
        this.dossierCredit.formeJuridique = this.corporate.customerLegalForm;
        this.dossierCredit.secteur = this.corporate.activityArea;
        this.dossierCredit.firstName = this.corporate.firstname;
        this.dossierCredit.lastName = this.corporate.lastname;
        this.dossierCredit.fonction = this.corporate.fonction;
        this.dossierCredit.experience = this.corporate.experience;
        this.dossierCredit.emailDirigeant = this.corporate.email;
        this.dossierCredit.telephoneDirigeant = this.corporate.mobilePhone;
        this.getListRequestItemByRequest(this.requestIdParent);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  getListRequestItemByRequest(requestIdParent) {
    this._requestItemService.getListRequestItemByRequest(requestIdParent).subscribe(
      (data) => {

        this.facilites = data;
        for(let i = 0; i < this.facilites.length - 1; i++)
        {
          this.addCredit();
        }

        this.form.controls.credits['controls'].forEach((controlGroup: any, index: number) => 
        {
          controlGroup.controls.requestType.setValue(this.facilites[index].produit.typeCredit.id);
          this.getListproduitByTypeCredit(index);
          controlGroup.controls.produit.setValue(this.facilites[index].produit.id);
          controlGroup.controls.produit.setValue(this.facilites[index].produit.id);
          controlGroup.controls.tauxInteret.setValue(this.facilites[index].taux);
          controlGroup.controls.montant.setValue(this.facilites[index].montant);
          controlGroup.controls.echeance.setValue(this.facilites[index].echeance);
          controlGroup.controls.nombreEcheance.setValue(this.facilites[index].nombreEcheance);
          controlGroup.controls.commissionOperationCredit.setValue(this.facilites[index].commissionOperationCredit);
          controlGroup.controls.fraisDossier.setValue(this.facilites[index].fraisDossier);
          controlGroup.controls.commissionEngagement.setValue(this.facilites[index].commissionEngagement);
          controlGroup.controls.payeurFinal.setValue(this.facilites[index].payeurFinal);
          controlGroup.controls.objetFinancement.setValue(this.facilites[index].objetFinancement);
        });

      },
      (error) => {
        console.log(error);
      }
    );
  }



  getAllLegalForm() {
    this._customerLegalFormService
      .getAllLegalForms()
      .pipe(
        timeout(5000),
        retry(3),
        catchError((error) => {
          console.error("Erreur lors de la récupération", error);
          return throwError(
            () => new Error("Erreur réseau. Veuillez réessayer plus tard.")
          );
        })
      )
      .subscribe(
        (data) => {
          this.legalForms = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getSecteur() {
    this._activityAreaService.getAllSecteurs().subscribe(
      (data) => {
        this.secteurs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListTypeCredit(index) {
    this._typeCreditService
      .getListTypeCreditByWorkflow(this.workflowCode)
      .pipe(
        timeout(5000),
        retry(3),
        catchError((error) => {
          console.error("Erreur lors de la récupération", error);
          return throwError(
            () => new Error("Erreur réseau. Veuillez réessayer plus tard.")
          );
        })
      )
      .subscribe(
        (data) => {
          this.requestTypes = data;
          this.requestTypeArray[index] = this.requestTypes;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getListproduitByTypeCredit(index) {
    this.produits = null;
    this.produitArray[index] = null;

    const typeCreditId = this.getCreditsFormGroup(index).value.requestType;
    //this.typeCreditLabel[index] = this.getCreditsFormGroup(index).value.requestType.code;

    this._produitService
      .getListproduitByTypeCredit(typeCreditId)
      .pipe(
        timeout(5000),
        retry(3),
        catchError((error) => {
          console.error("Erreur lors de la récupération", error);
          return throwError(
            () => new Error("Erreur réseau. Veuillez réessayer plus tard.")
          );
        })
      )
      .subscribe(
        (data) => {
          this.produits = data;
          this.produitArray[index] = this.produits;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  searchAndRefresh(): void {
    this.getBpCorporateBycodeclient(this.dossierCredit.customerCode);
  }

  getBpCorporateBycodeclient(codeclient) {
    this.spinner.show();

    this._bpCorporateService
      .getBpCorporateBycodeclient(codeclient)
      .pipe(
        timeout(5000),
        retry(3),
        catchError((error) => {
          console.error("Erreur lors de la récupération", error);
          return throwError(
            () => new Error("Erreur réseau. Veuillez réessayer plus tard.")
          );
        })
      )
      .subscribe(
        (data) => {
          this.bpCorporate = data;

          if (this.bpCorporate != null) {
            this.dossierCredit.accountNumber = this.bpCorporate.numcompte;
            this.dossierCredit.tradeRegister = this.bpCorporate.rccm;
            this.dossierCredit.ncc = this.bpCorporate.ncc;
            this.dossierCredit.corporateName = this.bpCorporate.raisonsociale;
            this.dossierCredit.capitalSocial = this.bpCorporate.capital;
            this.dossierCredit.address = this.bpCorporate.adresse;
            this.dossierCredit.email = this.bpCorporate.email;
            this.dossierCredit.telephone = this.bpCorporate.telephone;
            this.dossierCredit.lastName = this.bpCorporate.nomgerant;
            this.dossierCredit.firstName = this.bpCorporate.prenomgerant;

            if (
              this.bpCorporate.bpFonction != undefined &&
              this.bpCorporate.bpFonction != null
            ) {
              this.dossierCredit.fonction = this.bpCorporate.bpFonction.libelle;
            }

            this.dossierCredit.city = this.bpCorporate.commune;

            if (
              this.bpCorporate.customerLegalForm != undefined &&
              this.bpCorporate.customerLegalForm != null
            ) {
              this.dossierCredit.formeJuridique =
                this.bpCorporate.customerLegalForm;
            }

            if (
              this.bpCorporate.activityArea != undefined &&
              this.bpCorporate.activityArea != null
            ) {
              this.dossierCredit.secteur = this.bpCorporate.activityArea;
            }
          } else {
            this.dossierCredit.accountNumber = null;
            this.dossierCredit.tradeRegister = null;
            this.dossierCredit.ncc = null;
            this.dossierCredit.corporateName = null;
            this.dossierCredit.capitalSocial = null;
            this.dossierCredit.address = null;
            this.dossierCredit.email = null;
            this.dossierCredit.telephone = null;
            this.dossierCredit.lastName = null;
            this.dossierCredit.firstName = null;
            this.dossierCredit.fonction = null;
            this.dossierCredit.city = null;
            this.dossierCredit.formeJuridique = null;
            this.dossierCredit.secteur = null;
          }

          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  cancel(): void {
    this._router.navigate([document.referrer]);
  }
}
